module.exports = "/_next/static/images/Trend03Visual@2x-3d888879f855edd5713f7a857afafd43.webp";